import React, { useEffect, useState } from "react";
import { useI18n } from "../i18n/I18nProvider";
import api from "../lib/api";
import { Calendar } from "./ui/calendar";
import { addDays, format } from "date-fns";

export default function Availability({ onBook }) {
  const { t } = useI18n();
  const [range, setRange] = useState({ from: new Date(), to: addDays(new Date(), 2) });
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = async (from, to) => {
    if (!from || !to) return;
    setLoading(true);
    try {
      const start = format(from, "yyyy-MM-dd");
      const end = format(to, "yyyy-MM-dd");
      const { data } = await api.get(`/scooters/niu-nqix-500/availability`, { params: { start, end } });
      setData(data);
    } catch (e) { setData(null); }
    finally { setLoading(false); }
  };

  useEffect(() => {
    const from = new Date();
    const to = addDays(from, 30);
    load(from, to);
  }, []);

  const handleSelect = (r) => {
    setRange(r || {});
    if (r?.from && r?.to) load(r.from, r.to);
  };

  // Build a map dateString -> available
  const dayMap = {};
  (data?.days || []).forEach(d => { dayMap[d.date] = d.available; });

  return (
    <section id="availability" className="relative py-24 sm:py-32 bg-[#080808]" data-testid="availability-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="text-[11px] tracking-[0.35em] uppercase font-bold text-scooter-yellow mb-3">{t.avail.label}</div>
            <h2 className="font-heading font-black text-white text-4xl sm:text-5xl tracking-tighter leading-[0.95]">{t.avail.title}</h2>
            <p className="mt-6 text-zinc-400 leading-relaxed max-w-md">{t.avail.hint}</p>

            {data && range?.from && range?.to && (
              <div className="mt-8 bg-[#0a0a0a] border border-scooter-yellow/30 p-6">
                <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-zinc-500 mb-2">
                  {format(range.from, "dd MMM")} → {format(range.to, "dd MMM")}
                </div>
                <div className="font-heading font-black text-white text-3xl">
                  {Math.min(...(data.days || []).map(d => d.available))} / {data.units_total}
                </div>
                <div className="text-xs uppercase tracking-wider text-zinc-500 mt-1">scooter min. available</div>
                <button onClick={onBook} className="mt-6 w-full bg-scooter-yellow text-black font-bold text-xs tracking-[0.2em] uppercase h-12 hover:bg-scooter-yellow-hover" data-testid="avail-book-btn">
                  {t.nav.book}
                </button>
              </div>
            )}
          </div>
          <div className="lg:col-span-7">
            <div className="bg-[#0a0a0a] border border-white/10 p-4 sm:p-8">
              <Calendar
                mode="range"
                numberOfMonths={2}
                selected={range}
                onSelect={handleSelect}
                disabled={(date) => date < new Date(new Date().setHours(0,0,0,0))}
                className="text-white"
                data-testid="availability-calendar"
              />
              {loading && <div className="text-xs text-zinc-500 mt-2 text-center">Loading...</div>}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
